<div class="feedback-item">
    <div class="colored-bubble">
        <core-helpers-icons-colored-bubble-circle-letter [title]="shareItem.entry.user.name"
            [color]="getShareBubbleColor(shareItem)"></core-helpers-icons-colored-bubble-circle-letter>
    </div>
    <!-- old status  <span class="feedback-status" [style.background-color]="getApprovalColor(feedback.status.status_code)">{{feedback.status.status_text}}</span> -->
    <span class="feedback-status"> {{getShareStatusText(shareItem)}}</span>
    <span class="feedback-info"> by <strong>{{shareItem.entry.user.name}}</strong>
        <!-- updated 2024/02/06 <diego@twonas.com> display dates on all bubbles (version-shares) no matter the status -->
        <span> on {{shareItem.status.date | date: 'dd MMM yyyy'}}  at {{shareItem.status.date | date:'HH:mm'}}</span>
    </span>
    <!-- put the core component -->
    <core-helpers-navigation-three-dots-menu 
        *ngIf="menu"
        [menu]="menu"
        [dispatched]="triggered"
        (action)="onActionMenuClick($event)"></core-helpers-navigation-three-dots-menu>
</div>

